define('viewModels/dashboards/QualityAdminDashboard',[
    'lib/knockout',
    'moment',
    'services/qm/qualityAuth',
    'services/qm/qualityAdminState',
    'viewModels/dashboards/qualityAdminDashboard/CalibrationsWidget',
    'viewModels/dashboards/qualityAdminDashboard/EvaluatorActivityWidget',
    'viewModels/dashboards/qualityAdminDashboard/AgentActivityWidget',
    'viewModels/ViewModel',
    'viewModels/privileged/qm/policies/editors/DateRangeEditorView'
], function (
        ko,
        moment,
        qualityAuthorization,
        qualityAdminState,
        CalibrationsWidget,
        EvaluatorActivityWidget,
        AgentActivityWidget,
        ViewModel,
        DateRangeEditorView
    ) {
    'use strict';

    /**
     *  QualityAdmin Dashboard
     */
    var QualityAdminDashboard = ViewModel.extend(function () {
        var self = this;

        var startOfMonth = moment().startOf('month').toDate();
        var endOfMonth = moment().endOf('month').toDate();
        self.activityDateRange = ko.observableArray([startOfMonth.toISOString() + '/' + endOfMonth.toISOString()]);
        qualityAdminState.timeFrame(self.activityDateRange());
        self.dateRangesView = self.subView(DateRangeEditorView, self.activityDateRange);

        self.calibrationsWidget = self.subView(CalibrationsWidget, self.activityDateRange);
        self.evaluatorActivityWidget = self.subView(EvaluatorActivityWidget, self.activityDateRange);
        self.agentActivityWidget = self.subView(AgentActivityWidget, self.activityDateRange);
        self.canViewAgentAndEvaluationDashlets = qualityAuthorization.canAddEvaluation();
        self.canViewCalibration = qualityAuthorization.canViewCalibration();

        self.subscribe(self.activityDateRange, function(newDateRange){
            qualityAdminState.timeFrame(newDateRange);
        });
    });

    return QualityAdminDashboard;
});

